import axios from "axios";
export const getUsers = () => axios.get("/api/users");

export const getUser = (id) => axios.get(`/api/users/${id}`);

export const register = (user) => axios.post("/api/users", { ...user });

export const updateUser = (user) =>
  axios.put(`/api/users/${user._id}`, { ...user });
